import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import {
  CREATE_CUSTOMER,
  GET_CUSTOMER_BY_PHONE,
  REMOVE_PAYMENT_ID_FROM_CUSTOMER,
  UPDATE_CUSTOMER,
} from '../queries/customer.queries';
import { CustomerAddress, CustomerInput } from '../models/customer.model';
import { StorageService } from './storage.service';
import { LOCAL_STORAGE } from '../constants/local-storage.constants';
import { BehaviorSubject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { COOKIE_STORAGE } from '../constants/cookie.constants';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private customer: BehaviorSubject<CustomerInput>;
  constructor(
    private apollo: Apollo,
    private cookie: CookieService,
    private storageService: StorageService
  ) {
    let token = this.cookie.get(COOKIE_STORAGE.TOKEN);
    let userName;
    let userPhone;
    if (token && token !== 'undefined') {
      userName = JSON.parse(token)?.additionalInfo?.name;
      userPhone = JSON.parse(token)?.username;
    } else {
      userName = '';
      userPhone = '';
    }

    let customer: CustomerInput = new CustomerInput(
      '',
      userName,
      userPhone,
      '',
      '',
      '',
      '',
      '',
      []
    );
    this.customer = new BehaviorSubject<CustomerInput>(customer);
  }

  createCustomer(customer: CustomerInput) {
    return this.apollo.mutate({
      mutation: CREATE_CUSTOMER,
      variables: {
        customer: customer,
      },
    });
  }

  updateCustomer(id: string, customer: CustomerInput) {
		customer.address.forEach((add: CustomerAddress) => {
			// if ("id" in add) {
			// 	delete add.id;
			// }
			if ("isNew" in add) {
				delete add.isNew;
			}
			return add;
		});
		return this.apollo.mutate({
			mutation: UPDATE_CUSTOMER,
			variables: {
				id: id,
				customer: customer,
			},
		});
	}

  removeCustomerIdFromCustomer(id: string) {
    return this.apollo.mutate({
      mutation: REMOVE_PAYMENT_ID_FROM_CUSTOMER,
      variables: {
        id: id,
      },
    });
  }

  getCustomerAsObservable() {
    if (this.customer.value?.id.length === 0) {
      let customerObj = JSON.parse(
        this.storageService.getLocalStorageData(LOCAL_STORAGE.CUSTOMER_DETAILS)
      );
      this.setCustomerDetails(customerObj);
    }
    return this.customer.asObservable();
  }

  getCustomerByPhone(phone: String) {
    return this.apollo.watchQuery({
      query: GET_CUSTOMER_BY_PHONE,
      variables: {
        phone: phone,
      },
      fetchPolicy: 'network-only',
    }).valueChanges;
  }

  setCustomerDetails(customer: CustomerInput) {
    this.storageService.setLocalStorageData(
      LOCAL_STORAGE.CUSTOMER_ID,
      customer?.id ? customer?.id : ''
    );

    // customer?.address.forEach((add) => {
    //   return (add.id = 'id_' + Math.random().toString(16).slice(2));
    // });

    console.log(customer);
    this.customer.next(customer);
  }
}
